import { render, staticRenderFns } from "./StatusFlow.vue?vue&type=template&id=5bcf158f&scoped=true"
import script from "./StatusFlow.vue?vue&type=script&lang=js"
export * from "./StatusFlow.vue?vue&type=script&lang=js"
import style0 from "./StatusFlow.vue?vue&type=style&index=0&id=5bcf158f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf158f",
  null
  
)

export default component.exports